import * as Api from '../api/Api';
import createAxios from '../api/WiseOwl';

export function getMaskingConfigs() {
    return createAxios().get(Api.PATH_MASKING_CONFIGS);
}

export function getMaskingConfig(id) {
    return createAxios().get(`${Api.PATH_MASKING_CONFIGS}/${id}`);
}

export function createMaskingConfig(values) {
    return createAxios().post(Api.PATH_MASKING_CONFIGS, values);
}

export function updateMaskingConfig(id, values) {
    return createAxios().put(`${Api.PATH_MASKING_CONFIGS}/${id}`, values);
}

export function removeMaskingConfig(id) {
    return createAxios().delete(`${Api.PATH_MASKING_CONFIGS}/${id}`);
}
